import { render, staticRenderFns } from "./PredictPopup.vue?vue&type=template&id=e2b65e8a&scoped=true&"
import script from "./PredictPopup.vue?vue&type=script&lang=js&"
export * from "./PredictPopup.vue?vue&type=script&lang=js&"
import style0 from "./PredictPopup.vue?vue&type=style&index=0&id=e2b65e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b65e8a",
  null
  
)

export default component.exports